module.exports = __webpack_public_path__ + "static/media/  (47).ec463d3a.jpg";